'use client';

import { useTranslations } from 'next-intl';
import { Download, FileJson } from 'lucide-react';
import { toast } from 'sonner';
import type { Table } from '@/lib/table-features';
import { Button } from '@/components/ui/button';
import type { AuditLog } from '../types';
import { exportLogsAsCsv, exportLogsAsJson } from '../utils/export';

interface SystemLogsTableActionBarProps {
  table: Table<AuditLog>;
}

export function SystemLogsTableActionBar({
  table
}: SystemLogsTableActionBarProps) {
  const t = useTranslations('systemLogs');
  const selectedRows = table.getFilteredSelectedRowModel().rows;
  const selectedLogs = selectedRows.map((row) => row.original);

  const handleExportCsv = () => {
    exportLogsAsCsv(selectedLogs);
    toast.success(t('exportSuccess'));
    table.resetRowSelection();
  };

  const handleExportJson = () => {
    exportLogsAsJson(selectedLogs);
    toast.success(t('exportSuccess'));
    table.resetRowSelection();
  };

  return (
    <div className='bg-muted flex items-center gap-3 rounded-lg px-4 py-2'>
      <span className='text-muted-foreground text-sm font-medium'>
        {t('selectedCount', { count: selectedRows.length })}
      </span>
      <Button variant='outline' size='sm' onClick={handleExportCsv}>
        <Download className='me-1.5 size-4' />
        {t('exportCsv')}
      </Button>
      <Button variant='outline' size='sm' onClick={handleExportJson}>
        <FileJson className='me-1.5 size-4' />
        {t('exportJson')}
      </Button>
    </div>
  );
}
